import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';
import { Button } from 'ds/components/button';
import { BasicButtonProps } from 'ds/components/button/BasicButton';
import { MADAD_CARD_WIDTH } from 'components/madad/constants';


export const BaseCard = styled.div<{ isRegistered: boolean }>`
  ${({ theme, isRegistered }) => `
    display: flex;
    flex-direction: column;
    min-width: ${MADAD_CARD_WIDTH.default}px;
    max-width: ${MADAD_CARD_WIDTH.default}px;
    background-color: ${theme.colors.neutrals.white};
    border-radius: ${theme.borderRadius.small};
    border: solid 1px ${theme.colors.neutrals.grey8};
    overflow: hidden;
    ${isRegistered ? `
      cursor: pointer;
      box-shadow: ${theme.shadow.level2};
    ` : ''}
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    max-width: ${MADAD_CARD_WIDTH.large}px;
  `}
`;

export const CardUpperSection = styled.div`
  position: relative;
`;

export const CardContentSection = styled.div`
  ${({ theme }) => `
    padding: 44px ${theme.spacing(3)} ${theme.spacing(2.5)};
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `}
`;

export const CardContentDetails = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardCover = styled.div<{ imgUrl?: string }>`
  height: 92px;
  ${({ theme, imgUrl }) => imgUrl ? `
    background-repeat: no-repeat;
    background-size: cover;
    background-color: ${colorToAlpha(theme.colors.brand.main, 0.08)};
    background-image: url("${imgUrl}");
  ` : ''}
`;

export const TopTenBadgePosition = styled.div`
  ${({ theme }) => `
    position: absolute;
    top: 0;
    right: ${theme.spacing(2)};
  `}
`;

export const AvatarPosition = styled.div`
  ${({ theme }) => `
    position: absolute;
    margin: 0 auto;
    top: ${theme.spacing(4)};
    left: 0;
    right: 0;
    height: 88px;
    width: 88px;
  `}
`;

export const ContactButton = styled(Button)``;
export const contactButtonDefaultProps: BasicButtonProps = {
  mode: 'ghost',
  size: 'large',
  fullWidth: true,
};
ContactButton.defaultProps = contactButtonDefaultProps;

export const CardLink = styled.div`
  & > a {
    text-decoration: inherit;
    color: inherit;
    display: block;
  }
`;
